export default [

     {
          path: '/standard-ndi',
          name: 'StandardNdi',
          component: () => import("@/views/Page/StandardNdi/StandardNdi.vue"),
           meta: {
               title: '#Default# | QuestionNdi',
          },
     }
];